import React from "react";
import "./Gallery.scss";

const worldAreas = [
  {
    id: 1,
    className: "our-world-card our-world-card--cacao",
    image: "/images/our-world/cacao-wellness.png",
    title: "CACAO & WELLNESS",
    description: (
      <>
        Exceptional cacao.
        <br />
        A healthier, brighter tomorrow.
      </>
    ),
  },
  {
    id: 2,
    className: "our-world-card our-world-card--sports",
    image: "/images/our-world/sports-talent.png",
    title: "SPORTS & TALENT",
    description: (
      <>
        Developing talent.
        <br />
        Building brighter futures.
      </>
    ),
  },
  {
    id: 3,
    className: "our-world-card our-world-card--culture",
    image: "/images/our-world/culture-experiences.png",
    title: "CULTURE & EXPERIENCES",
    description: (
      <>
        People, culture and creativity
        <br />
        that move the world.
      </>
    ),
  },
  {
    id: 4,
    className: "our-world-card our-world-card--people",
    image: "/images/our-world/people-opportunity.png",
    title: "PEOPLE & OPPORTUNITY",
    description: (
      <>
        Empowering people.
        <br />
        Creating lasting opportunity.
      </>
    ),
  },
  {
    id: 5,
    className: "our-world-card our-world-card--future",
    image: "/images/our-world/future-innovation.png",
    title: "FUTURE & INNOVATION",
    description: (
      <>
        A more connected world.
        <br />
        Greater possibilities for generations.
      </>
    ),
  },
];

const Gallery = () => {
  return (
    <section className="our-world" id="our-world">
      <div className="our-world-background" aria-hidden="true"></div>

      <div className="our-world-container">
        <header className="our-world-heading">
          <span className="our-world-eyebrow">
            THE VIEWGENER ECOSYSTEM
          </span>

          <h2>OUR WORLD</h2>

          <p>
            One vision. A global ecosystem creating value across generations.
          </p>

          <div className="our-world-heading-line"></div>
        </header>

        <div className="our-world-grid">
          {worldAreas.map((area) => (
            <article
              className={area.className}
              key={area.id}
              style={{
                backgroundImage: `
                  linear-gradient(
                    180deg,
                    rgba(0, 0, 0, 0.05) 0%,
                    rgba(0, 0, 0, 0.20) 42%,
                    rgba(0, 0, 0, 0.94) 100%
                  ),
                  url("${area.image}")
                `,
              }}
            >
              <div className="our-world-card-glow" aria-hidden="true"></div>

              <div className="our-world-card-content">
                <span className="our-world-card-number">
                  {String(area.id).padStart(2, "0")}
                </span>

                <h3>{area.title}</h3>

                <p>{area.description}</p>
              </div>
            </article>
          ))}
        </div>

        <div className="our-world-action">
          <a
            href="#platforms"
            className="our-world-button"
            aria-label="Explore the ViewGener ecosystem"
          >
            <span>EXPLORE OUR ECOSYSTEM</span>
            <span className="our-world-button-arrow" aria-hidden="true">
              →
            </span>
          </a>

          <div className="our-world-action-line"></div>
        </div>
      </div>
    </section>
  );
};

export default Gallery;